import * as d3 from 'd3';
import { TickFormat } from './TickFormat';

export function renderTicks(selection: d3.selection.Update<{ ticks: TickFormat[] }>) {
    const ticksBound = selection.selectAll('.tick')
        .data(d => d.ticks);
    ticksBound
        .exit()
        .remove();
    const enterSelection = ticksBound
        .enter()
        .append('g')
        .classed('tick', true);
    enterSelection.append('line')
        .classed('tickLine', true);
    ticksBound
        .select('line')
        .attr('x1', d => d.line.x1)
        .attr('x2', d => d.line.x2)
        .attr('y1', d => d.line.y1)
        .attr('y2', d => d.line.y2)
        .attr('transform', d => `rotate(${d.line.rotate})`);
}
